import React from 'react';

const PageLoader = () => {
	return (
		<div
			className="d-flex justify-content-center align-items-center"
			style={{ height: '100%', marginTop: '20%' }}
		>
			<span
				className="Page_loader"
				role="status"
				aria-hidden="true"
			></span>
		</div>
	);
};

export default PageLoader;

export const PageSmallLoader = () => {
	return (
		<div
			className="Page_loader"
			style={{ width: '30px', height: '30px' }}
		></div>
	);
};
